import React, { useEffect } from 'react';
import { func, string } from 'prop-types';
import { eventNames, reportToSegment, types } from '@smartcar/morse';
import { Box, Typography } from '@mui/material';

import { TemplatesContainer, Template, TemplateName } from './styles';

import staticText from '../../../../../../../../localization/Application/webhooks';

// TODO: replace this template info will the template data from API once ready
const apiTemplates = [
  {
    name: 'ev_charge_management',
    displayName: 'EV Charge Management',
    description: 'Charging webhook template',
  },
  {
    name: 'diagnostics',
    displayName: 'Diagnostics',
    description: 'Diagnostic webhook template',
  },
];

const getTemplateIcon = (key) => {
  switch (key) {
    case 'diagnostics':
      return 'build';
    case 'ev_charge_management':
      return 'bolt';
    default:
      return 'tune';
  }
};

const WebhookTemplates = ({
  selectedTemplate,
  setNextEnabled,
  setSelectedTemplate,
}) => {
  const handleTemplateClick = (e) => {
    const { id, name } = e.currentTarget;
    if (selectedTemplate === id) {
      return;
    }
    setSelectedTemplate(id);
    setNextEnabled(true);
    reportToSegment(types.TRACK, eventNames.buttonClicked, {
      label: 'action',
      text: name,
    });
  };

  const templates = [
    ...apiTemplates,
    staticText.addModal.customTemplate,
  ];

  useEffect(() => {
    setNextEnabled(Boolean(selectedTemplate));
    reportToSegment(types.PAGE, 'Webhook Form - Templates');
  }, []);

  return (
    <TemplatesContainer data-testid="webhook-templates">
      <Box width="480px">
        <Typography variant="h1" sx={{ textTransform: 'none' }}>{staticText.addModal.stepperSections[0].title}</Typography>
        <Typography variant="body2" color="text.secondary" mt={2} mb={6}>{staticText.addModal.stepperSections[0].description}</Typography>
        {templates.map(template => (
          <Template
            key={template.name}
            id={template.name}
            name={template.displayName}
            onClick={handleTemplateClick}
            className={selectedTemplate === template.name ? 'selected' : ''}
            data-testid={`template-${template.name}`}
          >
            <Box display="flex" alignItems="center">
              <img src={`/assets/icons/webhooks/${getTemplateIcon(template.name)}.svg`} alt={template.displayName} />
            </Box>
            <div>
              <TemplateName variant="bold" color="text.primary">{template.displayName}</TemplateName>
              <Typography variant="body2" color="text.secondary" mt={0.5}>{template.description}</Typography>
            </div>
          </Template>
        ))}
      </Box>
    </TemplatesContainer>
  );
};

export default WebhookTemplates;

WebhookTemplates.propTypes = {
  selectedTemplate: string.isRequired,
  setSelectedTemplate: func.isRequired,
  setNextEnabled: func.isRequired,
};
